import { motion } from 'framer-motion';
import { scaleIn, staggerContainer, staggerItem } from '../../utils/animations';

const Mission = () => {
  return (
    <div className="container mx-auto px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-5xl mx-auto"
      >
        {/* Main Mission Statement */}
        <div className="text-center mb-16">
          <motion.div
            variants={scaleIn}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            className="inline-block"
          >
            <div className="text-8xl mb-6">🎯</div>
          </motion.div>
          
          <h2 className="text-4xl md:text-5xl font-display font-bold text-primary-green-dark mb-6">
            Our Mission
          </h2>
          
          <div className="w-24 h-1 bg-accent-orange mx-auto rounded-full mb-8"></div>
          
          <p className="text-2xl md:text-3xl font-display font-medium text-primary-green leading-relaxed mb-6">
            To inspire young minds through joyful learning experiences
          </p>
          
          <p className="text-lg md:text-xl text-neutral-gray-dark leading-relaxed max-w-3xl mx-auto">
            We believe every child deserves access to <strong className="text-primary-green">engaging, 
            educational content</strong> that makes learning feel like play. Through stories, puzzles, 
            and creative activities, we're building a generation of curious, confident learners! 🌈
          </p>
        </div>

        {/* Mission Pillars */}
        <motion.div
          variants={staggerContainer}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {missionPillars.map((pillar, index) => (
            <motion.div
              key={index}
              variants={staggerItem}
              whileHover={{ y: -8 }}
              className="relative"
            >
              <div className="card bg-gradient-to-br from-white to-accent-blue/5 h-full">
                {/* Number Badge */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-accent-orange rounded-full flex items-center justify-center text-white font-display font-bold text-xl shadow-lg">
                  {index + 1}
                </div>
                
                <div className="pt-4">
                  <div className="text-6xl mb-4 text-center">{pillar.icon}</div>
                  <h3 className="text-2xl font-display font-bold text-primary-green-dark mb-3 text-center">
                    {pillar.title}
                  </h3>
                  <p className="text-neutral-gray-dark leading-relaxed text-center">
                    {pillar.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Vision Statement */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-16 text-center"
        >
          <div className="card bg-gradient-to-br from-primary-green-light/20 to-accent-yellow/20 border-2 border-primary-green/20">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="text-4xl">🔭</span>
              <h3 className="text-3xl font-display font-bold text-primary-green-dark">
                Our Vision
              </h3>
              <span className="text-4xl">✨</span>
            </div>
            <p className="text-lg md:text-xl text-neutral-gray-dark leading-relaxed max-w-3xl mx-auto">
              To be the <strong className="text-primary-green">most loved children's magazine</strong> in 
              India, making quality education accessible and enjoyable for every child, everywhere.
            </p>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

// Mission pillars data
const missionPillars = [
  {
    icon: '📖',
    title: 'Engage',
    description: 'Captivating stories and content that hold children\'s attention and spark their curiosity.',
  },
  {
    icon: '🧠',
    title: 'Educate',
    description: 'Age-appropriate learning that builds knowledge, skills, and critical thinking.',
  },
  {
    icon: '🎉',
    title: 'Entertain',
    description: 'Fun-filled activities and puzzles that make learning an exciting adventure!',
  },
];

export default Mission;